export const cycle = function(input) {
  return function (times) {
    var i = 0,
      output = [];
    while (i < times) {
      output.push(input[i++ % input.length]);
    }
    return output;
  };
}